import _createClass from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @module ol/render/Event
 */
import Event from '../events/Event.js';

var RenderEvent = /*#__PURE__*/function (_Event) {
  _inherits(RenderEvent, _Event);

  var _super = _createSuper(RenderEvent);

  /**
   * @param {import("./EventType.js").default} type Type.
   * @param {import("../transform.js").Transform} [inversePixelTransform] Transform for
   *     CSS pixels to rendered pixels.
   * @param {import("../Map.js").FrameState} [frameState] Frame state.
   * @param {?(CanvasRenderingContext2D|WebGLRenderingContext)} [context] Context.
   */
  function RenderEvent(type, inversePixelTransform, frameState, context) {
    var _this;

    _classCallCheck(this, RenderEvent);

    _this = _super.call(this, type);
    /**
     * Transform from CSS pixels (relative to the top-left corner of the map viewport)
     * to rendered pixels on this event's `context`. Only available when a Canvas renderer is used, null otherwise.
     * @type {import("../transform.js").Transform|undefined}
     * @api
     */

    _this.inversePixelTransform = inversePixelTransform;
    /**
     * An object representing the current render frame state.
     * @type {import("../Map.js").FrameState|undefined}
     * @api
     */

    _this.frameState = frameState;
    /**
     * Canvas context. Not available when the event is dispatched by the map. For Canvas 2D layers,
     * the context will be the 2D rendering context.  For WebGL layers, the context will be the WebGL
     * context.
     * @type {CanvasRenderingContext2D|WebGLRenderingContext|undefined}
     * @api
     */

    _this.context = context;
    return _this;
  }

  return _createClass(RenderEvent);
}(Event);

export default RenderEvent;